/**
 * Internal helper that converts a string into camelCasing
 */
export function toCamelCase(str: string): string {
    return str
        .toLowerCase()
        .replace(/[\_\-\ ]+(\w)/g, (content, char: string) => char.toUpperCase());
}
